// App.js

import React from "react";
// import { SafeAreaProvider } from "react-native-safe-area-context";
import Main from "components/Main";

const App = () => {
  document.title = (process.env.REACT_APP_APPTITLE||"App Title");
  return (
    // <SafeAreaProvider>
      <Main style={{minHeight:"100%", width:"100%", minWidth:800}}></Main>
    // </SafeAreaProvider>
  );
};

export default App;
